export default "__VITE_ASSET__C5FAHvf6__"